export const zh = {
  nav: {
    about: '关于',
    chat: 'AI问答',
    experience: '职业经历',
    projects: '代表项目',
    research: '研究输出',
    contact: '联系',
  },
  hero: {
    greeting: '你好，我是',
    name: 'Stefans',
    title: 'Web3研究者 · DeFi协议专家 · 量化策略师 · AI Builder',
    subtitle: '从第一性原理研究协议机制，用量化与AI将洞察转化为可运行的策略、产品与研究系统。',
    rare_combo: '协议研究 × DeFi产品 × 量化策略 × AI系统——少见的复合型能力',
    cta_chat: '与AI分身对话',
    cta_projects: '查看代表项目',
    cta_research: '阅读Hyperliquid研报',
    badge_web3: 'Web3 & DeFi',
    badge_quant: '量化策略',
    badge_ai: 'AI Builder',
  },
  stats: {
    experience: '年技术与产品经验',
    tvl: 'TVL峰值',
    yield: '量化策略年化',
    articles: '篇研究文章',
    experience_label: '从传统互联网到DeFi全链条',
    tvl_label: 'KayaLand主动管理DeFi基金',
    yield_label: 'Martingale+LP联合策略',
    articles_label: '覆盖Web3全赛道公开发表',
  },
  about: {
    title: '关于我',
    subtitle: '不只是Web3的使用者，更是协议机制的研究者和策略的构建者',
    p1: '15年完整的技术-产品-量化链条。从传统互联网产品出发，经历DeFi Summer全周期，深度参与从RWA通证化、DeFi协议设计、投研分析，到链上量化策略研发的完整演进。',
    p2: '对Web3的热爱源于第一次读到Bitcoin白皮书时的震撼——中本聪用极简的设计解决了几千年的信任问题。这种第一性原理的思维方式影响了我理解每一个协议、每一个策略的方式。',
    p3: '当AI遇上Web3的可组合性，是我认为最值得投入的方向：一人+AI，可以做到传统团队才能完成的事。',
    tag_web3: 'DeFi协议深度',
    tag_quant: '量化策略',
    tag_ai: 'AI原生工作流',
    tag_research: '研究输出',
    tag_product: '从0到1产品',
    tag_teaching: '知识传播',
    capabilities_title: '我专注于四件事',
    capabilities: [
      { icon: '🔬', title: '协议机制研究', desc: '从第一性原理解构协议设计，Hyperliquid HFT基础设施、DeFi机制、Layer2技术路线' },
      { icon: '⚙️', title: 'DeFi产品与策略设计', desc: '从协议理解到产品落地，KayaLand TVL $2M+、UniOcean独立开发、RWA通证化实践' },
      { icon: '📈', title: '量化系统开发', desc: '自研多策略量化框架，Martingale+LP联合策略年化60%+，含Regime检测与风险管理' },
      { icon: '🤖', title: 'AI Agent与研究工具', desc: '将研究能力系统化为AI产品：数字分身、多Agent投研系统、DeFi信息Agent' },
    ],
  },
  chat: {
    title: '向我的AI直接提问',
    subtitle: '研究、项目、策略、经历——都可以问。基于真实背景构建，以我的视角回答。',
    placeholder: '问我任何问题，比如：你在Hyperliquid做了什么研究？',
    send: '发送',
    new_chat: '新对话',
    thinking: '思考中...',
    welcome: '你好！你可以问我关于我的Web3研究、DeFi产品、量化策略、AI系统，或者任何你想深入了解的问题。',
    suggestions: [
      '你在Hyperliquid方向做了哪些研究？',
      '你如何把协议研究转化为产品或策略？',
      'KayaLand $2M+ TVL是怎么做到的？',
      '你构建的多Agent投研系统是什么？',
    ],
    limit_chat: '当前对话已达消息上限，请开启新对话',
    limit_total: '今日对话次数已达上限（每日20条），明天重置后可继续',
    error: '发生错误，请稍后重试',
  },
  experience: {
    title: '经历',
    subtitle: '2018年至今的Web3旅程',
    pre_web3: '2018年之前：9年传统互联网技术与产品经验',
    items: [
      {
        year: '2026',
        title: 'Hyperliquid HFT基础设施研究',
        company: '技术顾问合作项目',
        desc: '受云服务商委托，完成Hyperliquid HFT做市基础设施全面调研，部署Non-Validating节点并系统研究HyperBFT共识机制与延迟特性。',
        bullets: ['输出面向HFT团队的完整实践指南', '量化节点抖动、延迟分布与做市优先机制'],
        tags: ['Hyperliquid', 'HFT', 'Node部署', '延迟研究'],
      },
      {
        year: '2024',
        title: '量化策略研究员 & AI产品开发者',
        company: '个人创业',
        desc: '自研多策略量化框架，同期将研究与分析能力系统化为多个AI产品。',
        bullets: ['Martingale+LP联合策略年化60%+，含Regime检测与风险管理', '构建AI数字分身、多Agent投研系统、DeFi信息Agent'],
        tags: ['量化策略', 'Uniswap V3', 'AI Agent', 'RAG'],
      },
      {
        year: '2022',
        title: 'Web3投研分析师 & 产品专家',
        company: '成都市度豫科技有限公司 · AKLabs',
        desc: '建立系统性的Web3项目研究与评估体系，并将知识沉淀为可传播的课程与内容。',
        bullets: ['主导AKLabs研究专栏，输出30+篇高质量研究文章', '独立设计并主讲30小时+的Web3全栈培训课程'],
        tags: ['投研', '内容创作', '团队培训', 'Airdrop策略'],
      },
      {
        year: '2020',
        title: 'DeFi产品经理',
        company: '成都优游信息技术有限公司',
        desc: '主导DeFi基金产品从0到1，在链上实现主动管理型策略的产品化落地。',
        bullets: ['KayaLand TVL峰值$2M+，年化收益50%', '独立开发UniOcean Uniswap V3仓位管理工具'],
        tags: ['DeFi产品', 'Uniswap V3', 'TVL $2M+', 'TypeScript'],
      },
      {
        year: '2018',
        title: '产品经理 · Web3方向',
        company: '成都优游信息技术有限公司',
        desc: '设计并推进PTOHome房产通证化平台，国内较早落地的RWA实践之一。',
        bullets: ['基于ERC20的房产份额化与收益分配方案', '项目销售额$1M+'],
        tags: ['RWA', 'ERC20', '产品设计'],
      },
    ],
  },
  projects: {
    title: '项目',
    subtitle: '从DeFi协议到AI系统的完整实践',
    all: '全部',
    defi: 'DeFi',
    ai: 'AI',
    quant: '量化',
    research: '研究',
    view: '查看',
    items: [
      {
        id: 'kayaland',
        title: 'KayaLand',
        subtitle: '去中心化基金平台',
        desc: '基于Uniswap V3集中流动性的主动管理型DeFi基金。TVL峰值$2M+，年化收益50%，全程主导产品设计与智能合约迭代。',
        tags: ['DeFi', 'Uniswap V3', 'TVL $2M+'],
        category: 'defi',
        highlight: 'TVL $2M+',
        link: null,
      },
      {
        id: 'hl-research',
        title: 'Hyperliquid HFT研究',
        subtitle: '做市基础设施技术研报',
        desc: '受云服务商委托，为HFT客户完成Hyperliquid基础设施全面调研。部署Non-Validating节点，研究HyperBFT共识机制、延迟特性与做市优先机制，输出完整实践指南。',
        tags: ['HFT', 'Hyperliquid', '节点部署', '延迟优化'],
        category: 'research',
        highlight: '2026 最新',
        link: '/research/hyperliquid-latency-deep-dive_cn.html',
      },
      {
        id: 'ai-twin',
        title: 'AI数字分身',
        subtitle: '可对话式个人简历展示平台',
        desc: '基于RAG的智能对话系统，将个人完整经历与思考做成可实时交互的AI。就是你现在看到的这个网站。',
        tags: ['AI', 'RAG', 'LLM API'],
        category: 'ai',
        highlight: '本站',
        link: 'https://ai.stefans.me',
      },
      {
        id: 'multi-agent',
        title: '多Agent投研系统',
        subtitle: '模拟华尔街分析师团队',
        desc: 'LLM驱动的多Agent系统，模拟不同角色分析师协作，自动生成结构化加密市场投研报告。',
        tags: ['AI', 'Multi-Agent', 'LLM', '投研'],
        category: 'ai',
        highlight: 'AI原生',
        link: null,
      },
      {
        id: 'uniocean',
        title: 'UniOcean',
        subtitle: 'Uniswap V3管理工具',
        desc: '独立设计并开发的Uniswap V3仓位管理工具，提供官方不具备的深度数据分析、区间可视化和仓位管理功能。',
        tags: ['DeFi', 'Uniswap V3', 'TypeScript', '独立开发'],
        category: 'defi',
        highlight: '独立开发',
        link: null,
      },
      {
        id: 'nexus-quant',
        title: 'Nexus-Quant框架',
        subtitle: '多策略量化交易系统',
        desc: '自研量化框架，含市场体制识别（regime detection）、摆动交易（swing/MSB）、alpha因子挖掘。Martingale+LP联合策略年化60%+。',
        tags: ['量化', 'Python', '策略回测', 'Regime检测'],
        category: 'quant',
        highlight: '年化 60%+',
        link: null,
      },
      {
        id: 'defi-agent',
        title: 'DeFi信息Agent',
        subtitle: 'Web3资讯自动化处理',
        desc: '自动从海量Web3资讯中筛选有价值信息，节省80%阅读时间，过滤90%+无效信息，支持自然语言深度追问。',
        tags: ['AI', 'DeFi', 'Agent', '自动化'],
        category: 'ai',
        highlight: '节省80%时间',
        link: null,
      },
      {
        id: 'ptohome',
        title: 'PTOHome',
        subtitle: '房产通证化平台（RWA）',
        desc: '基于ERC20的房产份额化方案，实现合规的房产投资与收益分配。项目销售额$1M+，国内较早的RWA实践之一（2018年）。',
        tags: ['RWA', 'ERC20', '产品设计'],
        category: 'defi',
        highlight: '销售额 $1M+',
        link: null,
      },
    ],
  },
  research: {
    title: '研究与作品集',
    subtitle: '公开发表的研究内容',
    view_all: '查看全部',
    items: [
      {
        title: 'Hyperliquid HFT基础设施研究',
        type: '技术研报',
        date: '2026年3月',
        desc: 'Hyperliquid Non-Validating节点部署、HyperBFT共识机制解析、延迟特性量化与做市策略可行性研究。面向HFT团队的完整实践指南。',
        tags: ['HFT', 'Hyperliquid', '节点部署'],
        link: '/research/hyperliquid-latency-deep-dive_cn.html',
        featured: true,
      },
      {
        title: '如何衡量好的代币经济学（三部曲）',
        type: '投研系列',
        date: '2023年2月',
        desc: '系统性分析代币经济学的评估框架，从概念定义到数量分析，到实际应用场景，覆盖通证经济学的完整维度。',
        tags: ['通证经济学', 'DeFi', '投研'],
        link: 'https://paragraph.com/@aklabs-2',
        featured: true,
      },
      {
        title: 'ZK/OP/模块化Layer2技术分析',
        type: '技术分析',
        date: '2023年2月',
        desc: '深度对比ZK Rollup、Optimistic Rollup与模块化区块链的技术路线，分析安全性假设与应用场景差异。',
        tags: ['Layer2', 'ZK', '模块化'],
        link: 'https://paragraph.com/@aklabs-2',
        featured: false,
      },
      {
        title: 'Aevo：去中心化永续合约赛道',
        type: '项目研究',
        date: '2023年12月',
        desc: '深度分析Aevo协议架构、订单簿模型、流动性机制与市场竞争格局。',
        tags: ['永续合约', 'DeFi', '项目尽调'],
        link: 'https://paragraph.com/@aklabs-2',
        featured: false,
      },
      {
        title: 'Veda Protocol：BTC智能合约',
        type: '项目研究',
        date: '2023年12月',
        desc: '基于Ordinals的Bitcoin智能合约协议研究，分析其技术架构与生态潜力。',
        tags: ['Bitcoin', 'Ordinals', '智能合约'],
        link: 'https://paragraph.com/@aklabs-2',
        featured: false,
      },
      {
        title: 'AKLabs研究专栏（30+篇）',
        type: '综合研究',
        date: '2022-2024年',
        desc: '涵盖通证经济学、Layer2技术、NFT/Ordinals、DeFi协议、空投策略等Web3全赛道研究。',
        tags: ['Web3', '综合研究', '30+篇'],
        link: 'https://paragraph.com/@aklabs-2',
        featured: false,
      },
    ],
  },
  footer: {
    tagline: 'Web3 × AI × 量化',
    desc: '探索协议边界，构建可运行的策略与产品',
    contact: '联系我',
    email_label: '邮箱',
    copyright: '© 2026 Stefans.',
    links: {
      email: 'stefans823@gmail.com',
      aklabs: 'https://paragraph.com/@aklabs-2',
    },
  },
}

export type I18nKeys = typeof zh
